import {Routes} from '@angular/router';
import {
  AccountStatementItemListReslover,
  AccountStatementsReslover,
  AdministratorsListReslover,
  ApplicationFormSettingsResolver,
  ApplicationFormSettingsListResolver,
  CategoriesResolver,
  CategoryResolver,
  CompetitorResultListResolver,
  CopyEventResolver,
  CopyRaceResolver,
  createEventCalendarResolver,
  createLeagueCalendarResolver,
  CurrentUserDetailsResolver,
  DiscountsDetailsResolver,
  eventCalendarCodebookResolver,
  EventCategoryResolver,
  eventCodebookResolver,
  EventDetailsPublicResolver,
  EventDetailsResolver,
  EventListResolver,
  EventPaymentSettingsResolver,
  EventRegistrationsResolver,
  FavoriteEventRacesResolver,
  generateCodebookResolvers,
  LeaguePublicResolover,
  LeagueReslover,
  LeaguesReslover,
  ListOfDiscountsResolver,
  ListOfLiveEventsResolver,
  LiveEventResolver,
  LiveRaceResolver,
  LiveResultsResolver,
  MessageResolver,
  NewEventsResolver,
  organiserCodebookResolver,
  OrganiserPaymentDataResolver,
  OrganizerRequestReslover,
  OrganizersListReslover,
  OrganizersRequestListResolver,
  RaceAdditionalPricingItemsPublicResolver,
  RaceAdditionalPricingItemsResolver,
  raceCodebookResolver,
  RaceCommercialItemsPublicResolver,
  RaceCommercialItemsResolver,
  RaceCompetitorsResolver,
  RaceDashboardFinishedResolver,
  RaceDashboardUpcomingResolver,
  RaceDetailsPublicResolver,
  RaceItemDetailsResolver,
  RaceRouteResolver, RaceSettingsResolver,
  registerToRaceCodebookResolver,
  RegisterToRaceResolver,
  UpcomingEventsResolver,
  UserListResolver,
  userProfileCodebookResolver,
  UserResolver,
  UserRoleResolver,
  WaypointListResolver,
  WsPayStatusResolver, RaceSettingsListResolver,
} from "@resolvers";
import {
  canActivateAdminGuard,
  canActivateAuthenticationGuard,
  canActivateChildAdminGuard,
  Features,
  Permission
} from "@services";
import {
  AccountStatementDetailsComponent,
  AdminEventDetailsComponent,
  AdminLeagueDetailsComponent,
  AdminRaceDetailsComponent,
  AdminTemplateComponent,
  CategoriesListComponent,
  ChangePasswordOnRecoveryComponent,
  ContactComponent,
  DiscountsDetailsComponent,
  ErrorStateComponent,
  EventCalendarComponent,
  EventDetailsComponent,
  EventDetailsComponentType,
  EventManagementComponent,
  EventPreviewComponent,
  LandingComponent,
  LeagueCalendarComponent,
  LeagueDetailsComponent,
  LeagueDetailsComponentType,
  ListOfAccountStatementsComponent,
  ListOfAdministratorsComponent,
  ListOfDiscountsComponent,
  ListOfEventsComponent,
  ListOfLeaguesComponent,
  ListOfOrganisersComponent,
  ListOfRequestsComponent,
  ListOfUsersComponent,
  LiveResultsComponent,
  LiveResultsRaceDetailsComponent,
  LoginComponent,
  MessagesComponent,
  OrganiserDetailsComponent,
  OrganizerDashboardComponent,
  PaymentComponent,
  PrivacyPolicyComponent,
  RaceDetailsComponent,
  RaceDetailsComponentType,
  RaceManagementComponentComponent,
  RecoverLostPasswordComponent,
  RegisterToRaceComponent,
  RequestDetailsComponent,
  SignupComponent,
  SignupVerificationComponent,
  UserDetailsComponent,
  UserProfileDashboardComponent,
  UserProfileEditComponent,
  UserProfileViewComponent
} from "@pages";
import {ApplicationFormSettings, EventItemType, RaceSettings} from "@model";
import {Input} from "@angular/core";

export const LANDING_ROUTE: string = "/landing";
export const EVENT_CALENDAR_ROUTE: string = "/eventCalendar";
export const PRIVATE_EVENT_CALENDAR_ROUTE: string = "/private/eventCalendar";
export const FINISHED_EVENTS_ROUTE: string = "/finishedEvents";
export const PRIVATE_FINISHED_EVENTS_ROUTE: string = "/private/finishedEvents";
export const SERIES_ROUTE: string = "/leagues";
export const SERIES_DETAILS: string = "leagueDetails";
export const PRIVATE_SERIES_ROUTE: string = "/private/leagues";
export const LOGIN_ROUTE: string = "/login";
export const USER_PROFILE_DASHBOARD_ROUTE: string = "/private/profile/userProfileDashboard";
export const USER_PROFILE_VIEW_ROUTE: string = "/private/profile/userProfileView";
export const USER_PROFILE_EDIT_ROUTE: string = "/private/profile/userProfileEdit";
export const SIGNUP_ROUTE: string = "/signup";
export const RECOVER_LOST_PASSWORD_ROUTE: string = "/recoverLostPassword";
export const REGISTER_TO_RACE: string = "registerToRace";
export const RACE_DETAILS: string = "raceDetails";
export const EVENT_DETAILS: string = "eventDetails";
export const PRIVACY_POLICY_ROUTE: string = "/privacy";
export const CONTACT_ROUTE: string = "/contact";
export const WSPAY_PAYMENT_SUCCESS: string = "/payment/success";
export const WSPAY_PAYMENT_ERROR: string = "/payment/error";
export const WSPAY_PAYMENT_CANCEL: string = "/payment/cancel";
export const LIVE_RESULTS: string = "/liveResults";
export const PRIVATE_LIVE_RESULTS: string = "/private/liveResults";
export const LIVE_RESULTS_RACE_DETAILS_FULL_SCREEN: string = "fullscreen/race";
export const LIVE_RESULTS_RACE_DETAILS: string = "race";

export const DETAILS: string = "details";
export const EDIT: string = "edit";
export const ADD: string = "add";
export const ORGANISER_LIST: string = "/private/admin/organisers";
export const ORGANISER_EDIT: string = "/private/admin/organisers/edit";
export const LIST_OF_REQUESTS: string = "/private/admin/requests";
export const ADMINISTRATOR_LIST: string = "/private/admin/administrators";
export const ACCOUNT_STATEMENTS: string = "/private/admin/accountStatements";
export const USER_LIST: string = "/private/admin/users";
export const ORGANISER_EVENTS: string = "/private/admin/events";
export const LEAGUES: string = "/private/admin/leagues";
export const ORGANISER_EVENT_EDIT: string = "/private/admin/events/edit";
export const ORGANISER_EVENT_ADD: string = "/private/admin/events/add";
export const ORGANISER_EVENT_COPY: string = "/private/admin/events/copy";
export const ORGANISER_EVENT_PREVIEW: string = "/private/admin/preview"
export const ORGANISER_RACE_EDIT_COPY: string = "/private/admin/events/copy/race/edit";
export const ORGANISER_RACE_EDIT: string = "/private/admin/events/race/edit";
export const ORGANISER_RACE_COPY: string = "/private/admin/events/race/copy";
export const ORGANISER_RACE_MANAGEMENT: string = "/private/admin/events/race/management";
export const ORGANISER_RACE_ADD: string = "/private/admin/events/race/add";
export const ORGANISER_DASHBOARD: string = "/private/admin/dashboard";
export const ORGANISER_PROFILE: string = "/private/admin/profile";
export const ORGANISER_MESSAGES: string = "/private/admin/messages";
export const USER_MESSAGES: string = "/private/messages";
export const ORGANISER_EVENTS_MANAGEMENT: string = "/private/admin/events/management";
export const CATEGORIES_LIST: string = "/private/admin/categories";
export const LIST_OF_DISCOUNTS: string = "/private/admin/discounts";
export const DISCOUNT_DETAILS: string = "discountDetails";

/// Web server should be correctly configured to handle 404 with index.html and not with error for browser history
function eventDetailsItem(path: string) {
  return {
    path: path,
    component: EventDetailsComponent,
    resolve: {
      eventDetails: EventDetailsPublicResolver,
      results: CompetitorResultListResolver,
      categories: CategoriesResolver,
      ...generateCodebookResolvers('countries', 'languages', 'currencies', 'genders')
    }
  };
}

function finishedRaceDetailsItem(path: string) {
  return {
    path: path,
    component: RaceDetailsComponent,
    resolve: {
      eventDetails: EventDetailsPublicResolver,
      raceDetails: RaceDetailsPublicResolver,
      competitors: RaceCompetitorsResolver,
      results: CompetitorResultListResolver,
      waypointList: WaypointListResolver,
      raceRoute: RaceRouteResolver,
      categories: CategoriesResolver,
      ...generateCodebookResolvers('languages', 'countries', 'genders')
    }
  };
}

function raceDetailsItem(path: string) {
  return {
    path: path,
    component: RaceDetailsComponent,
    resolve: {
      eventDetails: EventDetailsPublicResolver,
      raceDetails: RaceDetailsPublicResolver,
      raceCommercialItems: RaceCommercialItemsPublicResolver,
      raceAdditionalItems: RaceAdditionalPricingItemsPublicResolver,
      competitors: RaceCompetitorsResolver,
      results: CompetitorResultListResolver,
      waypointList: WaypointListResolver,
      raceRoute: RaceRouteResolver,
      categories: CategoriesResolver,
      ...generateCodebookResolvers('languages', 'countries', 'genders')
    },
  };
}

function registerToRaceItem(path: string, isPreviewComponent: boolean = false, isManagement: boolean = false) {
  return {
    path: path,
    component: RegisterToRaceComponent,
    data: {
      reuseComponent: false,
      isPreviewComponent: isPreviewComponent,
      isManagement: isManagement
    },
    resolve: {
      applicationFormSettings: ApplicationFormSettingsResolver,
      raceCommercialItems: RaceCommercialItemsPublicResolver,
      raceAdditionalItems: RaceAdditionalPricingItemsPublicResolver,
      eventItem: EventDetailsPublicResolver,
      currentUserDetails: CurrentUserDetailsResolver,
      race: RegisterToRaceResolver,
      ...generateCodebookResolvers('genders', 'sizes', 'transports', 'currencies', 'meals', 'countries', 'disciplines', 'languages'),
    },
  };
}

function commonMenuItems() {
  return [{
    path: 'eventCalendar',
    component: EventCalendarComponent,
    resolve: {
      ...eventCalendarCodebookResolver,
      listOfEvents: createEventCalendarResolver(EventItemType.UPCOMING),
      favoriteItems: FavoriteEventRacesResolver
    }
  },
    {
      path: 'eventCalendar',
      children: [
        eventDetailsItem('eventDetails'),
        raceDetailsItem('raceDetails'),
        {
          path: 'eventDetails',
          children: [
            raceDetailsItem('raceDetails'),
            registerToRaceItem('registerToRace'),
            {
              path: 'raceDetails',
              children: [
                registerToRaceItem('registerToRace'),
              ]
            },
          ]
        },
      ]
    },
    {
      path: 'finishedEvents',
      component: EventCalendarComponent,
      resolve: {
        ...eventCalendarCodebookResolver,
        listOfEvents: createEventCalendarResolver(EventItemType.FINISHED)
      }
    },
    {
      path: 'finishedEvents',
      children: [
        eventDetailsItem('eventDetails'),
        {
          path: 'eventDetails',
          children: [
            finishedRaceDetailsItem('raceDetails')
          ]
        },
      ]
    },
    {
      path: 'leagues',
      component: LeagueCalendarComponent,
      resolve: {
        ...generateCodebookResolvers('leaguesCountries', 'leaguesSports', 'languages'),
        listOfLeagues: createLeagueCalendarResolver(),
      }
    },
    {
      path: 'leagues',
      children: [
        {
          path: 'leagueDetails',
          component: LeagueDetailsComponent,
          resolve: {
            league: LeaguePublicResolover,
            ...generateCodebookResolvers('countries', 'languages')
          }
        },
        {
          path: 'leagueDetails',
          children: [
            eventDetailsItem('eventDetails'),
            raceDetailsItem('raceDetails'),
            {
              path: 'eventDetails',
              children: [
                raceDetailsItem('raceDetails'),
                registerToRaceItem('registerToRace'),
                {
                  path: 'raceDetails',
                  children: [
                    registerToRaceItem('registerToRace'),
                  ]
                },
              ]
            },
          ]
        },
      ]
    },
  ];
}

function liveResults() {
  return [{
    path: 'liveResults', component: LiveResultsComponent, resolve: {
      liveEvents: ListOfLiveEventsResolver,
      ...generateCodebookResolvers('languages', 'countries'),
    }
  },
    {
      path: 'liveResults',
      children: [{
        path: 'race',
        component: LiveResultsRaceDetailsComponent,
        resolve: {
          race: LiveRaceResolver,
          event: LiveEventResolver,
          liveResult: LiveResultsResolver,
          ...generateCodebookResolvers('languages', 'countries', 'genders'),
        },
      },
        {
          path: 'fullscreen/race',
          component: LiveResultsRaceDetailsComponent,
          resolve: {
            race: LiveRaceResolver,
            event: LiveEventResolver,
            liveResult: LiveResultsResolver,
            ...generateCodebookResolvers('languages', 'countries', 'genders'),
          },
          data: {isFullScreen: true}
        }]
    }
  ];
}

/// path strategy to work correctly, we don't won't web server to handle missing links instead let Angular handle that.
const routes: Routes = [
  {path: '', redirectTo: '/landing', pathMatch: 'full'},
  {path: 'contact', component: ContactComponent},
  {path: 'privacy', component: PrivacyPolicyComponent},
  {path: 'login', component: LoginComponent},
  {
    path: 'signup', component: SignupComponent, resolve: {
      ...generateCodebookResolvers('genders')
    }
  },
  {path: 'signupVerification', component: SignupVerificationComponent},
  {path: 'recoverLostPassword', component: RecoverLostPasswordComponent},
  {path: 'changePasswordOnRecovery', component: ChangePasswordOnRecoveryComponent},
  {path: 'emptyState', component: ErrorStateComponent},
  {path: 'payment', component: PaymentComponent},
  {
    path: 'payment',
    children: [{
      path: 'success',
      component: RegisterToRaceComponent,
      canActivate: [canActivateAuthenticationGuard()],
      resolve: {
        wspayConfirmation: WsPayStatusResolver,
        currentUserDetails: CurrentUserDetailsResolver,
        ...generateCodebookResolvers('currencies', 'languages')
      }
    },
      {
        path: 'error',
        component: RegisterToRaceComponent,
        canActivate: [canActivateAuthenticationGuard()],
        resolve: {
          wspayConfirmation: WsPayStatusResolver,
          currentUserDetails: CurrentUserDetailsResolver,
          ...generateCodebookResolvers('currencies', 'languages')
        }
      },
      {
        path: 'cancel',
        component: RegisterToRaceComponent,
        canActivate: [canActivateAuthenticationGuard()],
        resolve: {
          wspayConfirmation: WsPayStatusResolver,
          currentUserDetails: CurrentUserDetailsResolver,
          ...generateCodebookResolvers('currencies', 'languages'),
        }
      }
    ]
  },
  ...liveResults(),
  {
    path: 'private', children: [
      {
        path: 'admin', component: AdminTemplateComponent,
        resolve: {requests: OrganizersRequestListResolver, unreadMessages: MessageResolver,},
        children: [
          {path: 'dashboard', component: OrganizerDashboardComponent},
          {
            path: 'categories',
            component: CategoriesListComponent,
            resolve: {
              categories: CategoryResolver,
              ...generateCodebookResolvers('categoryTypes')
            },
            data: {permission: Permission.Edit, feature: Features.Categories}
          },
          {
            path: 'discounts', component: ListOfDiscountsComponent,
            resolve: {listOfDiscounts: ListOfDiscountsResolver},
          },
          {
            path: 'discounts', children: [
              {
                path: 'discountDetails',
                component: DiscountsDetailsComponent,
                resolve: {discount: DiscountsDetailsResolver}
              },
            ]
          },
          {
            path: 'profile',
            component: OrganiserDetailsComponent,
            data: {feature: Features.OrganiserProfile, permission: Permission.Edit},
            resolve: {
              users: UserListResolver,
              paymentData: OrganiserPaymentDataResolver,
              ...organiserCodebookResolver
            }
          },
          {
            path: 'events', component: ListOfEventsComponent,
            resolve: {
              events: EventListResolver,
              organisers: OrganizersListReslover,
              ...generateCodebookResolvers('eventStatuses', 'languages')
            },
          },
          {
            path: 'events',
            children: [
              {
                path: 'add', component: AdminEventDetailsComponent, resolve: {
                  organisers: OrganizersListReslover,
                  userRole: UserRoleResolver,
                  ...eventCodebookResolver
                },
                data: {type: EventDetailsComponentType.ADD}
              },
              {
                path: 'edit',
                component: AdminEventDetailsComponent,
                resolve: {
                  eventItem: EventDetailsResolver, paymentSettings: EventPaymentSettingsResolver,
                  organisers: OrganizersListReslover,
                  userRole: UserRoleResolver,
                  ...eventCodebookResolver
                },
                data: {type: EventDetailsComponentType.EDIT}
              },
              {
                path: 'copy',
                component: AdminEventDetailsComponent,
                resolve: {
                  eventItem: CopyEventResolver, paymentSettings: EventPaymentSettingsResolver,
                  organisers: OrganizersListReslover,
                  userRole: UserRoleResolver,
                  ...eventCodebookResolver
                },
                data: {type: EventDetailsComponentType.COPY}
              },
              {
                path: 'management',
                component: EventManagementComponent,
                resolve: {
                  eventItem: EventDetailsResolver,
                  competitors: RaceCompetitorsResolver,
                  raceRegistrations: EventRegistrationsResolver,
                  applicationFromSettingsList: ApplicationFormSettingsListResolver,
                  settingsList: RaceSettingsListResolver,
                  ...generateCodebookResolvers('languages')
                }
              },
              {
                path: 'management',
                children: [
                  registerToRaceItem('registerToRace', false, true)]
              },
              {
                path: 'copy', children: [
                  {
                    path: 'race',
                    children: [
                      {
                        path: 'edit',
                        component: AdminRaceDetailsComponent,
                        resolve: {
                          raceData: CopyRaceResolver,
                          raceCommercialItems: RaceCommercialItemsResolver,
                          raceAdditionalItems: RaceAdditionalPricingItemsResolver,
                          ...raceCodebookResolver
                        },
                        data: {type: RaceDetailsComponentType.EVENT_COPY}
                      },
                    ]
                  },
                ]
              },
              {
                path: 'race',
                children: [
                  {
                    path: 'add', component: AdminRaceDetailsComponent, resolve: {
                      event: EventDetailsResolver,
                      categories: EventCategoryResolver,
                      raceCommercialItems: RaceCommercialItemsResolver,
                      raceAdditionalItems: RaceAdditionalPricingItemsResolver,
                      waypointList: WaypointListResolver,
                      raceRoute: RaceRouteResolver,
                      ...raceCodebookResolver
                    },
                    data: {componentType: RaceDetailsComponentType.ADD}

                  },
                  {
                    path: 'edit', component: AdminRaceDetailsComponent, resolve: {
                      race: RaceItemDetailsResolver,
                      event: EventDetailsResolver,
                      categories: EventCategoryResolver,
                      raceCommercialItems: RaceCommercialItemsResolver,
                      raceAdditionalItems: RaceAdditionalPricingItemsResolver,
                      applicationFormSettings: ApplicationFormSettingsResolver,
                      raceSettings: RaceSettingsResolver,
                      waypointList: WaypointListResolver,
                      raceRoute: RaceRouteResolver,
                      ...raceCodebookResolver
                    },
                    data: {componentType: RaceDetailsComponentType.EDIT}
                  },
                  {
                    path: 'copy', component: AdminRaceDetailsComponent, resolve: {
                      race: CopyRaceResolver,
                      event: EventDetailsResolver,
                      categories: EventCategoryResolver,
                      raceCommercialItems: RaceCommercialItemsResolver,
                      raceAdditionalItems: RaceAdditionalPricingItemsResolver,
                      applicationFormSettings: ApplicationFormSettingsResolver,
                      raceSettings: RaceSettingsResolver,
                      waypointList: WaypointListResolver,
                      raceRoute: RaceRouteResolver,
                      ...raceCodebookResolver
                    },
                    data: {componentType: RaceDetailsComponentType.RACE_COPY}
                  },
                  {
                    path: 'management', component: RaceManagementComponentComponent, resolve: {
                      race: RaceItemDetailsResolver,
                      eventItem: EventDetailsResolver,
                      raceCommercialItems: RaceCommercialItemsResolver,
                      raceAdditionalItems: RaceAdditionalPricingItemsResolver,
                      applicationFormSettings: ApplicationFormSettingsResolver,
                      competitors: RaceCompetitorsResolver,
                      results: CompetitorResultListResolver,
                      categories: CategoriesResolver,
                      raceSettings: RaceSettingsResolver,
                      ...registerToRaceCodebookResolver
                    }
                  },
                  {
                    path: 'management',
                    children: [
                      registerToRaceItem('registerToRace', false, true)]
                  },
                ]
              }
            ]
          },
          {
            path: 'preview', component: EventPreviewComponent, resolve: {
              eventItem: EventDetailsPublicResolver,
              ...eventCalendarCodebookResolver
            },
            data: {isPreview: true}
          },
          {
            path: 'preview', children: [
              eventDetailsItem('eventDetails'),
              {
                path: 'eventDetails',
                children: [
                  registerToRaceItem('registerToRace', true),
                  raceDetailsItem('raceDetails'),
                  {
                    path: 'raceDetails',
                    children: [
                      registerToRaceItem('registerToRace', true),
                    ]
                  }
                ]
              }
            ],
            data: {isPreview: true}
          },
          {
            path: 'requests',
            component: ListOfRequestsComponent,
            resolve: {
              requests: OrganizersRequestListResolver,
              ...generateCodebookResolvers('requestStatuses', 'requestTypes', 'languages')
            },
            data: {feature: Features.RequestsList, permission: Permission.Edit}
          },
          {
            path: 'requests',
            children: [{
              path: 'details',
              component: RequestDetailsComponent,
              resolve: {request: OrganizerRequestReslover, ...generateCodebookResolvers('genders')},
              data: {feature: Features.RequestsList, permission: Permission.Edit}
            },]
          },
          {
            path: 'administrators',
            component: ListOfAdministratorsComponent,
            resolve: {administrators: AdministratorsListReslover},
            data: {feature: Features.Administrators, permission: Permission.Edit}
          },
          {
            path: 'accountStatements',
            component: ListOfAccountStatementsComponent,
            resolve: {accountStatements: AccountStatementsReslover},
            data: {feature: Features.AccountStatements, permission: Permission.Edit}
          },
          {
            path: 'accountStatements',
            children: [
              {
                path: 'details',
                component: AccountStatementDetailsComponent,
                resolve: {
                  accountStatements: AccountStatementsReslover,
                  accountStatementItemList: AccountStatementItemListReslover,
                  ...generateCodebookResolvers('languages')
                },
                data: {feature: Features.AccountStatementsDetails, permission: Permission.Edit}
              },
            ]
          },
          {
            path: 'leagues',
            component: ListOfLeaguesComponent,
            resolve: {
              leagues: LeaguesReslover, ...generateCodebookResolvers('languages')
            },
            data: {feature: Features.LeaguesList, permission: Permission.Edit}
          },
          {
            path: 'leagues',
            children: [
              {
                path: 'edit',
                component: AdminLeagueDetailsComponent,
                resolve: {
                  league: LeagueReslover, organisers: OrganizersListReslover,
                  ...generateCodebookResolvers('languages', 'sports', 'countries')
                },
                data: {feature: Features.LeagueDetails, permission: Permission.Edit}
              },
              {
                path: 'add', component: AdminLeagueDetailsComponent, resolve: {
                  organisers: OrganizersListReslover,
                  userRole: UserRoleResolver,
                  ...generateCodebookResolvers('languages', 'sports', 'countries')
                },
                data: {type: LeagueDetailsComponentType.ADD}
              },
            ]
          },
          {
            path: 'users',
            component: ListOfUsersComponent,
            resolve: {users: UserListResolver},
            data: {feature: Features.Users, permission: Permission.Edit}
          },
          {
            path: 'users', children: [
              {
                path: 'details', component: UserDetailsComponent,
                resolve: {
                  user: UserResolver,
                  ...userProfileCodebookResolver
                },
                data: {feature: Features.Users, permission: Permission.Edit}
              },
            ]
          },
          {
            path: 'organisers',
            component: ListOfOrganisersComponent,
            resolve: {organisers: OrganizersListReslover},
            data: {feature: Features.OrganisersList, permission: Permission.Edit}
          },
          {
            path: 'organisers', children: [
              {
                path: 'edit',
                component: OrganiserDetailsComponent,
                data: {feature: Features.OrganisersEdit, permission: Permission.Edit},
                resolve: {
                  users: UserListResolver,
                  paymentData: OrganiserPaymentDataResolver,
                  listOfDiscounts: ListOfDiscountsResolver,
                  categories: CategoryResolver,
                  ...organiserCodebookResolver,
                }
              },
              {
                path: 'edit', children: [{
                  path: 'discountDetails',
                  component: DiscountsDetailsComponent,
                  resolve: {discount: DiscountsDetailsResolver}
                }
                ]
              },
              {
                path: 'add',
                component: OrganiserDetailsComponent,
                data: {feature: Features.OrganisersEdit, permission: Permission.Edit}, resolve: {
                  ...organiserCodebookResolver
                }
              },
            ]
          },
          {
            path: 'messages',
            component: MessagesComponent,
            resolve: {
              messages: MessageResolver,
            },
            data: {
              isAdmin: true
            }
          }
        ], canActivate: [canActivateAdminGuard()], canActivateChild: [canActivateChildAdminGuard()]
      },
      ...liveResults(),
      {
        path: 'profile',
        children: [
          {
            path: 'userProfileDashboard',
            component: UserProfileDashboardComponent,
            resolve: {
              ...generateCodebookResolvers('languages', 'countries'),
              favoriteItems: FavoriteEventRacesResolver
            }
          },
          {
            path: 'userProfileDashboard',
            children: [
              eventDetailsItem('eventDetails'),
              finishedRaceDetailsItem('raceDetails'),
              finishedRaceDetailsItem('eventDetails/raceDetails'),
              registerToRaceItem('eventDetails/registerToRace'),
              registerToRaceItem('raceDetails/registerToRace'),
              registerToRaceItem('eventDetails/raceDetails/registerToRace')
            ]
          },
          {
            path: 'userProfileView', component: UserProfileViewComponent, resolve: {
              ...userProfileCodebookResolver,
              currentUserDetails: CurrentUserDetailsResolver,
              raceUpcomingEvents: RaceDashboardUpcomingResolver,
              favoriteItems: FavoriteEventRacesResolver,
              finishedRaces: RaceDashboardFinishedResolver,
              unreadMessages: MessageResolver
            }
          },
          {
            path: 'userProfileView',
            children: [
              eventDetailsItem('eventDetails'),
              raceDetailsItem('eventDetails/raceDetails')
            ]
          },
          {
            path: 'userProfileEdit', component: UserProfileEditComponent, resolve: {
              ...userProfileCodebookResolver
            }
          },
        ]
      },
      {
        path: 'messages',
        component: MessagesComponent,
        resolve: {
          messages: MessageResolver
        },
        data: {isAdmin: false}
      },
      ...commonMenuItems()
    ], canActivate: [canActivateAuthenticationGuard()]
  },
  {
    path: 'landing',
    component: LandingComponent,
    resolve: {
      upcomingItems: UpcomingEventsResolver,
      newItems: NewEventsResolver,
      ...generateCodebookResolvers('countries', 'languages')
    }
  },
  {
    path: 'landing',
    children: [
      eventDetailsItem('eventDetails'),
      raceDetailsItem('raceDetails'),
      {
        path: 'eventDetails',
        children: [
          raceDetailsItem('raceDetails'),
          registerToRaceItem('registerToRace'),
          {
            path: 'raceDetails',
            children: [
              registerToRaceItem('registerToRace'),
            ]
          },
        ]
      },
    ]
  },
  ...commonMenuItems(),
  {path: '**', redirectTo: '/landing'}
];

export default routes;
